import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/Context/AuthContext";
import DocumentList from "../../pages/DocumentList/DocumentList";
import { Box, Button, Typography, Alert, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FloatingInstructions from "../../components/FloatingInstructions/FloatingInstructions";
import axios from "axios";
import API_BASE_URL from "../../utils/api";
import { Link as MuiLink } from "@mui/material";
import MyContributionSummary from "../../components/MyContributionSummary/MyContributionSummary";

const Transcription = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [activeEvent, setActiveEvent] = useState(null);
  const [eventMessage, setEventMessage] = useState("");
  const [eventError, setEventError] = useState("");

  useEffect(() => {
    const fetchActiveEvent = async () => {
      try {
        if (!localStorage.getItem("token")) return;
        const res = await axios.get(`${API_BASE_URL}/transcribeathon/active`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setActiveEvent(res.data);
      } catch (err) {
        setActiveEvent(null);
      }
    };

    fetchActiveEvent();
  }, []);

  const handleJoinEvent = async () => {
    try {
      if (!activeEvent?._id) return;
      setEventMessage("");
      setEventError("");

      const res = await axios.post(
        `${API_BASE_URL}/transcribeathon/${activeEvent._id}/join`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setEventMessage(res.data.message || "Joined event");
    } catch (err) {
      setEventError(err.response?.data?.error || "Failed to join event");
    }
  };

  const handleOpenLeaderboard = () => {
    if (!activeEvent?._id) return;
    navigate(`/transcribeathon-events/${activeEvent._id}`);
  };

  return (
    <Box
      sx={{
        width: "auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      {" "}
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        sx={{
          marginTop: 1,
          color: "#111111",
          backgroundColor: "#fff7db",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "#fff1bf",
          },
        }}
        onClick={() => navigate(`/dh-hub`)}
      >
        View All Features{" "}
      </Button>
      <FloatingInstructions />{" "}
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Get Started with Transcription{" "}
      </Typography>{" "}
      <Typography
        variant="body1"
        sx={{
          marginBottom: "5px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        Welcome to the Mississippi Digital Humanities Hub transcription tool! We
        appreciate your help transcribing documents. Transcription makes
        documents easier to search and easier to discover.{" "}
      </Typography>{" "}
      <Typography
        variant="body1"
        sx={{
          marginBottom: "5px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        These instructions are for Southern Miss transcriptions. If you are
        working on a project for a different institution, they may have their
        own guidelines.{" "}
      </Typography>{" "}
      <Typography
        variant="body1"
        sx={{
          marginBottom: "10px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        Documents are transcribed and reviewed by volunteers. It takes at least
        one volunteer to transcribe a page and at least one different volunteer
        to review and mark it complete. Review ensures transcriptions are whole
        and accurate. Complex documents may pass through transcription and
        review several times before they are completed.{" "}
      </Typography>
      {!user && (
        <Box
          sx={{
            mt: 3,
            mb: 2,
            px: { xs: 2, sm: 2.5 },
            py: 2,
            backgroundColor: "#fff7db",
            borderLeft: "4px solid #e0b92f",
            borderRadius: "4px",
            display: { xs: "block", sm: "flex" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Sign in to transcribe
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 0.4,
                color: "#555",
              }}
            >
              Your contributions and time spent will be saved to your account.
            </Typography>
          </Box>

          <Button
            variant="contained"
            onClick={() => navigate("/login")}
            sx={{
              flexShrink: 0,
              backgroundColor: "#111",
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#333",
                boxShadow: "none",
              },
            }}
          >
            Sign In
          </Button>
        </Box>
      )}
      {user && <MyContributionSummary />}
      <DocumentList />{" "}
    </Box>
  );
};

export default Transcription;
